import {
  ImageFragment,
  ProductFragment,
} from "client/graphql/commerce-v2-api"
import { TilePriceWrapper } from "client/packages/commerce/components/product/MultiProductTile"
import { PreviewWrapper } from "client/packages/commerce/components/product/ProductPreview"
import { Price } from "client/packages/commerce/components/ui/priceComponents/Price"
import { ProductTitle } from "client/packages/commerce/components/ui/textStyles"
import styled from "styled-components"

import ImageCarousel from "./TargetImageCarousel"

const TargetProductDetails = styled.div`
  margin-top: 10px;
  font-family: "Target", Helvetica, sans-serif !important;

  ${ProductTitle} {
    margin: 15px 0 10px;
  }
`

export interface ProductPreviewProps {
  product: ProductFragment
  images: ImageFragment[]
  currencyCode: string
  price: string
  openImageGallery?: (initialImgIndex?: number) => void
}

const ProductPreview = ({
  product,
  images,
  currencyCode,
  price,
  openImageGallery = () => {},
}: ProductPreviewProps) => (
  <PreviewWrapper>
    <ImageCarousel images={images} openImageGallery={openImageGallery} />
    <TargetProductDetails>
      <ProductTitle>{product.title}</ProductTitle>
      <TilePriceWrapper>
        <Price
          amount={price}
          currencyCode={currencyCode}
          showCurrencyCode={false}
        />
      </TilePriceWrapper>
    </TargetProductDetails>
  </PreviewWrapper>
)

export default ProductPreview
